<template>
  <div class="search-community">

      <div class="search-sec">
          <input :class="{'bg-logo': iflogo}" type="text" placeholder="搜索小区" v-model="keywords" @focus="nologo" @blur="haslogo" ref="search-sec">
      </div>

      <div class="search-res" v-if="communities.length != 0">
            <h3>{{title}}</h3>
            <ul class="community-lists">
            <li class="community-item" v-for="(item, index) in communities" :key="index">
                <div class="img-logo">
                    <img v-if="item.image" :src="item.image">
                    <span v-else>楼里楼外</span>
                </div>
                <div class="info" @click="addMyHouse(item.token)">
                    <h4>{{item.village_name}}</h4>
                    <p>{{item.property_name}}</p>
                    <span>{{item.address}}</span>
                </div>
            </li>
        </ul>
      </div>

      <div class="search-none" v-else-if="search_nearby_status == 1">
          正在搜索附近小区
      </div>
      <div class="search-none" v-else-if="keywords == '' && communities.length == 0">
          附近没有开通缴费的小区
      </div>
      <div class="search-none" v-else>
          您搜索的小区可能暂时还未开通微信缴费，<br />
          我们正在努力争取中，如有疑问可电话咨询<br />
          <span>400-6082-089</span>
      </div>
      <iframe id="geoPage" width=0 height=0 frameborder=0  style="display:none;" scrolling="no"
            src="https://apis.map.qq.com/tools/geolocation?key=7GIBZ-UYM6I-ONRG6-5WTUQ-USWHS-XTBDH&referer=myvue">
      </iframe>
  </div>
</template>
<script>
export default {
  data () {
    return {
      iflogo: true, // 判断搜索logo
      userId:'',
      token:'',     //指级别
      property_token:'',     //指级别
      city_id: '',     //指级别
      all_village: [],
      communities: [],
      keywords: '',
      title: '',
      loc: '',
      search_nearby_status: 1,    //正在搜索附近小区
    };
  },
  watch:{
     keywords: function(val){
          if(val){
              // this.search_nearby_status = 0;  //不是搜索附近小区
              this.title = '搜索结果';
              this.communities = [];
              this.all_village.forEach((item,index)=>{
                  if(item.village_name.indexOf(val) != -1 ){
                      this.communities.push(item);
                  }
              });
          }else{
              this.getNearbyVillage();
          }
    }
  },
  created () {
      this.userId = this.$route.query.userId;
      this.token = this.$route.query.v_token;
      this.property_token = this.$route.query.property_token;
      this.city_id = this.$route.query.city_id;
      this.getLocation();
  },
  methods: {
    // 控制logo
    nologo() {
      this.iflogo = false;
    },
    haslogo() {
      this.iflogo = true;
    },

    getLocation() {
        let vueThis = this;
        window.addEventListener('message', function(event) {
            if(event.data == null){
              return false;
            }
            if(!event.data.hasOwnProperty('lat')){
              return false;
            }
            if (event.data.lat && !vueThis.loc) {
                vueThis.loc = event.data // 接收位置信息
                if (vueThis.loc) {
                  vueThis.getVillageList();
                  // console.log(vueThis.loc)
                    // alert(vueThis.loc.lat)
                    // alert(vueThis.loc.lng)
                }
            }
        }, false)

        // 设置6s超时，防止定位组件长时间获取位置信息未响应
        setTimeout(function() {
            if (!vueThis.loc) {
                // alert('定位超时');
                vueThis.getVillageList();
            }
        }, 2000) // 6s为推荐值，业务调用方可根据自己的需求设置改时间，不建议太短
    },
    getVillageList(){
        this.$indicator.open();
        let data = JSON.stringify({'city_id':this.city_id,'latitude':this.loc.lat,'longitude':this.loc.lng});
        this.axios.get('/jmobile/Register/getxq_wechat/json/'+data).then((res)=>{
            this.$indicator.close();
            if(res.data.status == '1'){
                this.all_village = res.data.data;
                // if(this.loc){
                  this.getNearbyVillage();
                // }
            }else{
                this.$toast({
                  message:res.data.info,
                  position:'bottom',
                  duration:'2000'
                });
            }
        }).catch((response)=>{
            this.$toast({
              message:'网络错误',
              position:'bottom',
              duration:'2000'
            });
        });
    },
    getNearbyVillage(){
        this.search_nearby_status = 1;  //正在搜索
        this.title = '';
        if(this.loc){
          this.title = '附近小区';
          this.communities = [];
          this.all_village.forEach((item,index)=>{
              if(item.latitude > 0 && item.distance <= 3 ){
                  this.communities.push(item);
              }
          });
        }else{
          this.communities = this.all_village;
        }
        
        this.search_nearby_status = 0;  //搜索结束
    },
    // 添加我的房屋, 该方法里的v_token 指选择的小区
    addMyHouse (v_token) {
         this.$router.push({name: 'SelectCommunity', query: {v_token:v_token,token:this.token,userId:this.userId,property_token:this.property_token,city_id:this.city_id,jump:this.$route.query.jump}});  //jump参数可指定添加完房屋跳到的主件
      
    },

    
  }
};
</script>
<style lang="less">
.search-community {
  box-sizing: border-box;
  position: relative;
  background: #f5f5f5;
  height: 100%;
  width: 100%;
  font-size: 13px;
  .search-sec {
    box-sizing: border-box;
    padding: 10px 15px 15px;
    border-bottom: 1px solid #ececec;
    background: #fff;
    input {
      box-sizing: border-box;
      padding: 0 10px;
      background-color: #efefef;
      width: 100%;
      color: #999;
      height: 30px;
      line-height: 30px;
      border-radius: 20px;
      &.bg-logo {
        padding-left: 140px;
        background-image: url(../assets/search.png);
        background-size: 14px 14px;
        background-repeat: no-repeat;
        background-position: 120px center;
      }
    }
  }
  .search-res {
    position: absolute;
    top: 56px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    h3 {
      padding: 22px 15px 10px;
      font-weight: normal;
      color: #666;
    }
    .community-lists {
      padding: 0 15px;
      .community-item {
        display: flex;
        box-sizing: border-box;
        padding: 16px 0 14px;
        min-height: 90px;
        border-bottom: 1px solid #ececec;
        .img-logo {
          margin-right: 14px;
          width: 60px;
          height: 60px;
          line-height: 60px;
          border-radius: 50%;
          overflow: hidden;
          border: none;
          background: #efefef;
          color: #ccc;
          text-align: center;
          font-size: 12px;
          img {
            width: 100%;
            height: 100%;
            border: none;
          }
        }
        .info {
          flex: 1;
          line-height: 26px;
          color: #666;
          h4 {
            font-size: 14px;
            font-weight: normal;
            color: #333;
          }
          span {
            display: block;
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
  }
  .search-none {
    position: absolute;
    padding-top: 112px;
    top: 50%;
    left: 50%;
    width: 100%;
    text-align: center;
    line-height: 26px;
    background-image: url(../assets/search-none.png);
    background-repeat: no-repeat;
    background-size: 150px 82px;
    background-position: center top;
    transform: translate3d(-50%, -50%, 0);
    span {
      color: #ffaf14;
      font-size: 16px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/SearchCommunity.vue